/* eslint-disable prefer-const */
import React from 'react'
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  createHttpLink,
  ApolloLink,
  from,
  Observable,
} from '@apollo/client'
import { API_GRAPHQL_URL, API2_GRAPHQL_URL } from 'shared/get-env'
import { API_V2 } from 'constants/apollo'
import { onError } from '@apollo/client/link/error'
import HttpStatus from './constants'
import AuthSevice from 'services/auth'
import { REFRESH_USER_ACCESS_TOKEN_V2 } from 'services/auth/graphql'

export let apolloClient

const httpLink = createHttpLink({
  uri: API_GRAPHQL_URL,
  credentials: 'include',
})

const httpLinkV2 = createHttpLink({
  uri: API2_GRAPHQL_URL,
  credentials: 'include',
})

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'ignore',
  },
  query: {
    errorPolicy: 'all',
  },
}

export const getNewToken = () => {
  return apolloClient
    .mutate({
      mutation: REFRESH_USER_ACCESS_TOKEN_V2,
      context: {
        clientName: API_V2,
      },
    })
    .then(response => {
      return response.data?.refreshUserAccessToken
    })
}

const errorLink = onError(({ graphQLErrors, operation, forward }) => {
  if (graphQLErrors) {
    const notAuthorized = graphQLErrors.some(({ extensions }) => {
      if (extensions?.originalError) {
        return (
          extensions?.originalError?.statusCode === HttpStatus.NOT_AUTHORIZED
        )
      }
      return false
    })

    if (notAuthorized) {
      if (!AuthSevice.role) {
        AuthSevice.removeCredentials().then(success => {
          if (success) {
            window.alert('Successfully logged out')
            window.location.href = '/sign-in'
          } else {
            window.alert('Failed to log out')
          }
        })
        // End the observable chain, do not retry
        return Observable.of()
      }

      // Return an Observable that waits for the token refresh, then retries
      return new Observable(observer => {
        getNewToken()
          .then(data => {
            // Optionally, you could update headers here if needed
            // Retry the request
            const subscriber = forward(operation).subscribe({
              next: result => observer.next(result),
              error: err => observer.error(err),
              complete: () => observer.complete(),
            })
            // Cleanup
            return () => {
              if (subscriber) subscriber.unsubscribe()
            }
          })
          .catch(async () => {
            const success = await AuthSevice.removeCredentials()
            if (success) {
              window.alert('Successfully logged out')
              window.location.href = '/sign-in'
            } else {
              window.alert('Failed to log out')
            }
            observer.complete()
          })
      })
    } else {
      return forward(operation)
    }
  }
  return undefined
})

apolloClient = new ApolloClient({
  link: ApolloLink.split(
    operation => operation.getContext()?.clientName === API_V2,
    from([errorLink, httpLinkV2]), // if api v2 in context
    from([errorLink, httpLink]),
  ),
  cache: new InMemoryCache({
    addTypename: false,
    possibleTypes: {
      pagination: ['PaginationResponse'],
    },
  }),
  defaultOptions,
})

/**
 * @hoc Инициализация подключения apollo для работы с API
 */
const withApollo = component => () =>
  <ApolloProvider client={apolloClient}>{component()}</ApolloProvider>

export default withApollo
